module.exports = __webpack_public_path__ + "3df6a367744d01f50bb8872ccc714d2c.pdf";